<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/bug.svg" size="2"></app-svg>
  <h1>Virus detected</h1>
  <p>
    We detected a virus in a file that was uploaded (<b>{{ asset().version_data.asset_name }}</b
    >). This file has been removed.
  </p>
  <button
    appButton
    name="confirm"
    location="file-removed-dialog"
    data-test-id="confirm-deletion"
    color="warn"
    (click)="close()"
    height="4"
    size="3"
    shape="round"
    weight="bold"
    spacing="full"
  >
    Ok
  </button>
</div>
